"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { Children, type ReactNode } from "react";
import DropCurationButton from "../DropCurationButton";
import WaveDropReactions from "../WaveDropReactions";
import { ParticipationDropRatings } from "./ParticipationDropRatings";
interface ParticipationDropFooterProps {
  readonly drop: ExtendedDrop;
  readonly voteAction?: ReactNode;
  readonly showInteractions?: boolean | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export default function ParticipationDropFooter(t0) {
  const $ = _c(29);
  const {
    drop,
    voteAction,
    showInteractions: t1,
    winningThreshold,
    isVotingClosed: t2,
    isVotingControlsLocked: t3
  } = t0;
  const showInteractions = t1 === undefined ? true : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const isVotingControlsLocked = t3 === undefined ? false : t3;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const isVotingActionLocked = isVotingClosed || isVotingControlsLocked;
  const canShowVoting = canShowVote && !isVotingActionLocked;
  const canShowCuration = drop.context_profile_context?.curatable ?? false;
  const hasRatings = drop.raters_count > 0;
  const hasWinningThreshold = typeof winningThreshold === "number" && winningThreshold > 0;
  const shouldShowRatings = hasRatings || hasWinningThreshold;
  const hasReactions = drop.reactions.length > 0;
  let t4;
  if ($[0] !== voteAction) {
    t4 = Children.toArray(voteAction);
    $[0] = voteAction;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const normalizedVoteAction = t4;
  const hasVoteAction = normalizedVoteAction.length > 0;
  const hasPrimaryActions = canShowCuration || hasVoteAction;
  const shouldShowVoteFooter = canShowVoting && (shouldShowRatings || hasPrimaryActions);
  const shouldShowRatingsOnlyFooter = !canShowVoting && shouldShowRatings;
  const shouldShowReactionsFooter = hasReactions || !canShowVoting && canShowCuration;
  if (!showInteractions) {
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-pb-4" />;
      $[2] = t5;
    } else {
      t5 = $[2];
    }
    return t5;
  }
  let t5;
  if ($[3] !== canShowCuration || $[4] !== drop || $[5] !== hasPrimaryActions || $[6] !== isVotingClosed || $[7] !== normalizedVoteAction || $[8] !== shouldShowRatings || $[9] !== shouldShowVoteFooter || $[10] !== winningThreshold) {
    t5 = shouldShowVoteFooter && <div className="tw-mt-4 tw-@container sm:tw-ml-[3.25rem]" onClick={_temp}><div className="tw-flex tw-flex-col tw-gap-x-4 tw-gap-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-justify-between">{shouldShowRatings && <div className="tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} /></div>}{hasPrimaryActions && <div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-px-6 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-none @[700px]:tw-px-4 @[700px]:tw-pt-0"><DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />{normalizedVoteAction}</div>}</div></div>;
    $[3] = canShowCuration;
    $[4] = drop;
    $[5] = hasPrimaryActions;
    $[6] = isVotingClosed;
    $[7] = normalizedVoteAction;
    $[8] = shouldShowRatings;
    $[9] = shouldShowVoteFooter;
    $[10] = winningThreshold;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== drop || $[13] !== isVotingClosed || $[14] !== shouldShowRatingsOnlyFooter || $[15] !== winningThreshold) {
    t6 = shouldShowRatingsOnlyFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} /></div>;
    $[12] = drop;
    $[13] = isVotingClosed;
    $[14] = shouldShowRatingsOnlyFooter;
    $[15] = winningThreshold;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== canShowCuration || $[18] !== canShowVoting || $[19] !== drop || $[20] !== shouldShowReactionsFooter) {
    t7 = shouldShowReactionsFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-flex tw-w-[calc(100%-3.25rem)] tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1 tw-px-4 tw-pb-4">{!canShowVoting && <DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />}<WaveDropReactions drop={drop} /></div>;
    $[17] = canShowCuration;
    $[18] = canShowVoting;
    $[19] = drop;
    $[20] = shouldShowReactionsFooter;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== shouldShowReactionsFooter) {
    t8 = !shouldShowReactionsFooter && <div className="tw-pb-4" />;
    $[22] = shouldShowReactionsFooter;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = <>{t5}{t6}{t7}{t8}</>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp(e) {
  return e.stopPropagation();
}